import styled from "styled-components";
import { InputComponentProps } from "../../types/types";

const Wrapper = styled.div<InputComponentProps>`
  display: flex;
  flex-direction: column;
  outline: ${(props) => (props.outline ? "1px dashed blue" : "none")};
  width: ${(props) => (props.width ? props.width : "36vw")};
`;

const LabelArea = styled.div`
  display: flex;
  align-items: start;
`;

const Label = styled.p<InputComponentProps>`
  font-size: ${(props) => (props.$labelSize ? props.$labelSize : "2.2vw")};
  font-weight: ${(props) =>
    props.$labelFontWeight ? props.$labelFontWeight : "500"};
`;

const Required = styled.p<InputComponentProps>`
  font-size: "4vw";
  font-weight: "500";
  color: #ff7f3b;
  margin-left: 0.4vw;
`;

const InputBoxArea = styled.div<InputComponentProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vw;
  border: 0.2vw solid #d8d8d8;
  border-radius: ${(props) =>
    props.$borderRadius ? props.$borderRadius : "1vw"};
  width: ${(props) => (props.width ? props.width : "36vw")};
  height: ${(props) => (props.height ? props.height : "5.6vw")};
  padding: 1vw;
`;

const TextAreaBoxArea = styled.div<InputComponentProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vw;
  border: 0.2vw solid #d8d8d8;
  border-radius: ${(props) =>
    props.$borderRadius ? props.$borderRadius : "1vw"};
  width: ${(props) => (props.width ? props.width : "36vw")};
  height: ${(props) => (props.height ? props.height : "12vw")};
  padding: 1vw;
`;

const TextAreaBox = styled.textarea<InputComponentProps>`
  display: flex;
  justify-content: start;
  outline: none;
  border: none;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "100%")};
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : "2vw")};
  font-weight: ${(props) => (props.$fontWeight ? props.$fontWeight : "500")};
  font-family: "Pretendard";
  resize: none;
  &&::placeholder {
    color: #8b8b8b;
    font-weight: 300;
    font-size: 2.2vw;
  }
`;

const InputBox = styled.input<InputComponentProps>`
  display: flex;
  justify-content: start;
  outline: none;
  border: none;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "4vw")};
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : "2vw")};
  font-weight: ${(props) => (props.$fontWeight ? props.$fontWeight : "500")};
  &&::placeholder {
    color: #8b8b8b;
    font-weight: 300;
    font-size: 2vw;
    font-family: "Pretendard";
  }
`;

export default function CustomInputComponent(props: InputComponentProps) {
  const {
    outline,
    label,
    width,
    height,
    isRequired,
    isTextArea,
    placeholder,
    value,
    name,
    readOnly,
    $backgroundColor,
    $borderRadius,
    $color,
    $fontSize,
    $fontWeight,
    onChangeInput,
  } = props;

  return (
    <Wrapper outline={outline} width={width}>
      <LabelArea>
        <Label>{label}</Label>
        {isRequired && <Required>*</Required>}
      </LabelArea>
      {/* true이면 Input 대신에 TextArea를 사용 */}
      {isTextArea ? (
        <TextAreaBoxArea width={width} height={height}>
          <TextAreaBox
            placeholder={placeholder}
            width={width}
            value={value}
            name={name}
            onChange={onChangeInput}
            readOnly={readOnly}
          ></TextAreaBox>
        </TextAreaBoxArea>
      ) : (
        <InputBoxArea width={width} height={height}>
          <InputBox
            placeholder={placeholder}
            width={width}
            value={value}
            name={name}
            onChange={onChangeInput}
            readOnly={readOnly}
          ></InputBox>
        </InputBoxArea>
      )}
    </Wrapper>
  );
}
